// extracted by mini-css-extract-plugin
export default {"info":"All_info__hT8pT"};